exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-label[data-v-00ca9dc9]{width:30%}.file-input-error[data-v-00ca9dc9]{color:#dc3545;margin-top:2rem}.image-preview[data-v-00ca9dc9]{z-index:1}", ""]);

// exports
